import { ISidebarSubNav } from '@efex-components/sidebar/config';
import { Grid, MenuItem, Paper, Popper, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { t } from 'i18next';
import { Link } from 'react-router-dom';

interface FloatSubmenuProps {
  title?: string;
  anchorEl: HTMLElement | null;
  subLinks: ISidebarSubNav[];
  navItemRef: string;
}

const FloatSubmenu = ({
  title,
  anchorEl,
  subLinks,
  navItemRef,
}: FloatSubmenuProps) => {
  const isMobile = useMediaQuery('(min-width:768px)');

  if (!isMobile) {
    return null;
  }

  return (
    <Popper
      open={!!anchorEl && (anchorEl as any).href.includes(navItemRef)}
      anchorEl={anchorEl}
      role={undefined}
      placement="right"
      className="z-[10000] !left-[-20px] w-full max-w-[500px]"
      sx={{
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        m: 3,
        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: '50%',
          left: -5,
          width: 10,
          height: 10,
          bgcolor: 'background.paper',
          transform: 'translateY(-50%) rotate(-45deg)',
          zIndex: 0,
        },
      }}
    >
      <Paper>
        {title ? (
          <div className="!py-2 w-full text-center border-b !border-slate-300">
            <Typography className="!text-lg !font-semibold">
              {t(title)}
            </Typography>
          </div>
        ) : null}
        <Grid container className="p-3">
          {subLinks.map((subLink) => (
            <Grid
              item
              xs={12}
              md={6}
              key={subLink.link}
              className={subLink.classNames}
            >
              <Link to={subLink.link} className="hover:text-[#016bf8]">
                <MenuItem>
                  {subLink.icon}
                  {t(subLink.section)}
                </MenuItem>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Popper>
  );
};

export default FloatSubmenu;
